import pathsManifest from './pathsManifest';
import DevPage from './components/pages/DevPage';
import DashboardPage from './components/pages/DashboardPage';
import TermsPage from './components/pages/TermsPage';
import NativeAppSignInPage from './components/pages/NativeAppSignInPage';
import WaitlistConfirmationPage from './components/pages/WaitlistConfirmationPage';
import NotFoundPage from './components/pages/NotFoundPage';

const routes = [
  {
    exact: true,
    strict: false,
    component: DevPage,
    path: '/',
  },
  {
    exact: true,
    component: DashboardPage,
    path: pathsManifest.dashboard,
  },
  {
    component: TermsPage,
    path: pathsManifest.termsPage + '(/)?([?].*)?',
  },
  {
    component: NativeAppSignInPage,
    path: pathsManifest.nativeAppSignInPage + '(/)?([?].*)?',
  },
  {
    exact: true,
    component: WaitlistConfirmationPage,
    path: pathsManifest.waitlistConfirmationPage + '(/)?([?].*)?',
  },
  {
    component: NotFoundPage,
    path: '*',
  },
];

export default routes;
